import { render, staticRenderFns } from "./DownloadUpload.vue?vue&type=template&id=cad5b976&"
import script from "./DownloadUpload.vue?vue&type=script&lang=js&"
export * from "./DownloadUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports